(function ($) {

    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    const chwrapper = $('#ch-wrapper');
    let navbarHeight = chwrapper.outerHeight();
    const mlogo = $('#ch-main-logo');
    const slogo = $('#ch-secondary-logo');
    const menu = $('#ch-menu');
    const footer = $('#footer_line');

    footer.hide();


    // slogo.on('mouseover', function() {
    //     menu.fadeIn();
    //     chwrapper.removeClass('no-background');
    // });

    console.log('test');
    console.log(wilatevars.blog_id);
    console.log('test2');
    if ($(".page-template-vertical-slider").length > 0) {

        const wrapper = $('#panelWrap');
        
        slogo.on('click', function() {
            $(wrapper).animate({scrollTop: '0px'}, 300);
        });

        wrapper.scroll(function (event) {
            didScroll = true;
        });
        
        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            let st = wrapper.scrollTop();
        
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;
        
            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                if(wilatevars.blog_id != 7) {
                    mlogo.hide();
                slogo.show();
                chwrapper.addClass('small');
                }
                
               
                //menu.fadeOut();
                //chwrapper.addClass('no-background');
            
            } else {
                // Scroll Up
                // if (st + wrapper.height() < $(document).height()) {
    
                //     mlogo.show();
                //     slogo.hide();
                //     chwrapper.removeClass('small');
                //     //menu.fadeIn();
                //     //chwrapper.removeClass('no-background');
                // }
            }
        
            lastScrollTop = st;
        }
        
        
         
    } else {

        slogo.on('click', function() {
            $('html, body').animate({scrollTop: '0px'}, 300);
        });

        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            let st = $(window).scrollTop();
        
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;
        
            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                if(wilatevars.blog_id != 7) {
                mlogo.hide();
                slogo.show();
                chwrapper.addClass('small');
                }
                //menu.fadeOut();
                //chwrapper.addClass('no-background');
            
            } else {
                // Scroll Up
                // if (st + $(window).height() < $(document).height()) {
    
                //     mlogo.show();
                //     slogo.hide();
                //     chwrapper.removeClass('small');
                //     //menu.fadeIn();
                //     //chwrapper.removeClass('no-background');
                // }
            }

            
            if (st + $(window).height() + footer.height() >= $('body').height() - footer.height()) {
                footer.fadeIn();
            } else {
                footer.fadeOut();
            }
        
            lastScrollTop = st;
        }
    }




})(jQuery);

